import useStashwiseStore from "@/hooks/useStashwiseStore";
import { LANDING_NAV_ITEMS } from "@/utils/constants";
import { Button } from "@nextui-org/react";
import Link from "next/link";
import { useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";

const LandingSideBar = () => {
  const { setMenuOpen, menuOpen, setOpenModal } = useStashwiseStore();

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  return (
    <section
      className={`fixed inset-0 md:hidden flex flex-col justify-between  bg-[#0F0326] p-8 text-[#ffffff]  z-20 transition-transform duration-300 ease-in-out ${
        menuOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="space-y-8">
        <div className="flex justify-between items-center">
          <AiOutlineClose
            size={32}
            onClick={() => setMenuOpen(false)}
            className="cursor-pointer"
          />
          <p className="font-semibold text-2xl">Menu</p>
        </div>
        <div className="space-y-4">
          {LANDING_NAV_ITEMS.map(({ title, href }, index) => {
            return (
              <div key={index} onClick={() => setMenuOpen(false)}>
                <Link href={href} className={` ${index > 5 ? "" : "text-2xl"}`}>
                  {title}
                </Link>
              </div>
            );
          })}
        </div>
      </div>

      <Button
        onPress={() => setOpenModal("downloadMobile", true)}
        className="bg-[#ffffff] text-[#0F0326] rounded-[5px] font-semibold hover:bg-opacity-80 hover:transition-all duration-300 w-full"
      >
        Download App
      </Button>
    </section>
  );
};

export default LandingSideBar;
